/*
 * @Author: Gaho
 * @Date: 2024-06-12 14:24:49
 * @LastEditors: Gaho
 * @LastEditTime: 2025-01-23 13:45:13
 * @Description: 
 */
import plinkoJackpotImg from '@/assets/imgs/jackpot/plinko-jackpot.webp';
import diceJackpotImg from '@/assets/imgs/jackpot/dice-jackpot.webp';
import hiloJackpotImg from '@/assets/imgs/jackpot/hilo-jackpot.webp';
import crashJackpotImg from '@/assets/imgs/jackpot/crash-jackpot-new.webp';

export const jackpotData = {
    'Dice': {
        img: {
            src: diceJackpotImg,
            text: ''
        },
        desc: {
            text1: 'diceDescText1',
            text2: 'rest',
            textInfo: ''
        },
        // jackpot 百分比展示数据
        percentData: [
            {
                percent: '5%',
                bet_amount_pre: '0.000015',
                bet_amount_suf: '00',
                bet_currency: 'BTC'
            },
            {
                percent: '30%',
                bet_amount_pre: '0.00014999',
                bet_amount_suf: '',
                bet_currency: 'BTC'
            },
            {
                percent: '50%',
                bet_amount_pre: '0.0025',
                bet_amount_suf: '0000',
                bet_currency: 'BTC'
            }
        ],
        historyData: [], // 打开窗口有接口查询此处数据，并赋值至此 
    },
    'Plinko': {
        img: {
            src: plinkoJackpotImg,
            text: ''
        },
        desc: {
            text1: 'plinkoDescText1',
            text2: 'rest',
            textInfo: ''
        },
        // jackpot 百分比展示数据
        percentData: [
            {
                percent: '5%',
                bet_amount_pre: '0.00005',
                bet_amount_suf: '000',
                bet_currency: 'BTC'
            },
            {
                percent: '20%',
                bet_amount_pre: '0.0001',
                bet_amount_suf: '0000',
                bet_currency: 'BTC'
            },
            {
                percent: '50%',
                bet_amount_pre: '0.005',
                bet_amount_suf: '00000',
                bet_currency: 'BTC'
            }
        ],
        historyData: []
    },
    'Circle': {
        img: {
            src: '',
            text: 'circleImgText'
        },
        desc: {
            text1: 'circleDescText1',
            text2: 'rest',
            textInfo: ''
        },
        // jackpot 百分比展示数据
        percentData: [
            {
                percent: '10%',
                bet_amount_pre: '0.000015',
                bet_amount_suf: '00',
                bet_currency: 'BTC'
            },
            {
                percent: '30%',
                bet_amount_pre: '0.00014999',
                bet_amount_suf: '',
                bet_currency: 'BTC'
            },
            {
                percent: '60%',
                bet_amount_pre: '0.0025',
                bet_amount_suf: '0000',
                bet_currency: 'BTC'
            }
        ],
        historyData: []
    },
    'Space Dice': {
        img: {
            src: '',
            text: '',
            info: ['7 - - -', '7 7 - -', '7 7 - -', '7 7 - -']
        },
        desc: {
            text1: 'spaceDiceDescText1',
            text2: 'spaceDiceDescText2',
            text3: 'spaceDiceDescText3',
            textInfo: ['spaceDiceDescInfo1', 'spaceDiceDescInfo2', 'spaceDiceDescInfo3', 'spaceDiceDescInfo4', 'spaceDiceDescInfo5']
        },
        // jackpot 百分比展示数据
        percentData: [
            {
                percent: '5%',
                bet_amount_pre: '0.000015',
                bet_amount_suf: '00',
                bet_currency: 'BTC'
            },
            {
                percent: '30%',
                bet_amount_pre: '0.00014999',
                bet_amount_suf: '',
                bet_currency: 'BTC'
            },
            {
                percent: '50%',
                bet_amount_pre: '0.0025',
                bet_amount_suf: '0000',
                bet_currency: 'BTC'
            }
        ],
        historyData: []
    },
    'Hilo': {
        img: {
            src: hiloJackpotImg,
            text: ''
        },
        desc: {
            text1: 'hiloDescText1',
            text2: 'rest',
            textInfo: ''
        },
        // jackpot 百分比展示数据
        percentData: [
            {
                percent: '5%',
                bet_amount_pre: '0.000033',
                bet_amount_suf: '00',
                bet_currency: 'BTC'
            },
            {
                percent: '25%',
                bet_amount_pre: '0.00042',
                bet_amount_suf: '000',
                bet_currency: 'BTC'
            },
            {
                percent: '30%',
                bet_amount_pre: '0.005',
                bet_amount_suf: '00000',
                bet_currency: 'BTC'
            }
        ],
        historyData: []
    },
    'Crash': {
        img: {
            src: crashJackpotImg,
            text: ''
        },
        desc: {
            text1: 'crashDescText1',
            text2: 'rest',
            textInfo: '',
            text4: 'crashDescText4'
        },
        // jackpot 百分比展示数据
        percentData: [
            {
                percent: '10%',
                bet_amount_pre: '0.00003',
                bet_amount_suf: '000',
                bet_currency: 'BTC'
            },
            {
                percent: '30%',
                bet_amount_pre: '0.00029999',
                bet_amount_suf: '',
                bet_currency: 'BTC'
            },
            {
                percent: '70%',
                bet_amount_pre: '0.005',
                bet_amount_suf: '00000',
                bet_currency: 'BTC'
            }
        ],
        historyData: []
    },
}